export enum UserType {
  SUPPORT = 'support',
  PATIENT = 'patient',
}

export const TaskUserTypeNameMAPPER: Record<UserType, string> = {
  [UserType.SUPPORT]: 'Support',
  [UserType.PATIENT]: 'Patient',
};

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const GOOGLE_ADDRESS_EMPTY_VALUE = {
  addressLine1: '',
  city: '',
  country: '',
  county: '',
  description: '',
  latitude: undefined,
  longitude: undefined,
  name: '',
  placeId: '',
  state: '',
  timezone: '',
  zipCode: '',
};

// patient Contact dropdown
export const LivesWithPatients = ['Yes', 'No'];

// We need to send the userId as null when updating a task but as "none" when filtering
export const UNASSIGNED_OPTION: AutoCompleteOption = {
  primaryText: 'Unassigned',
  secondaryText: [],
  value: null,
};
export const UNASSIGNED_USER: User = {
  firstName: 'Unassigned',
  lastName: '',
  userId: null,
};
export const UNASSIGNED_PATIENT: User = {
  firstName: 'No patient linked',
  lastName: '',
  userId: null,
};
export const UNASSIGNED_PATIENT_OPTION: AutoCompleteOption = {
  primaryText: 'No patient linked',
  secondaryText: [],
  value: 'none',
};
export const UNASSIGNED_FILTER_OPTION = {
  primaryText: 'Unassigned',
  secondaryText: [],
  value: 'none',
};

export const USER_FILTER_ADMIN = 'admin';
export const USER_FILTER_MAUD = 'maud';

export enum ProviderTypeNames {
  ADMISSIONS_OPERATIONS = 'Admissions Operations',
  ADMISSIONS_SPECIALIST = 'Admissions Specialist',
  ADMISSIONS_SUPERVISOR = 'Admissions Supervisor',
  MEDICAL_ASSISTANT = 'Medical Assistant',
  PATIENT_SERVICE_REPRESENTATIVE = 'Patient Service Representative',
  PRACTICE_COORDINATOR = 'Practice Coordinator',
}

export const UNASSIGNED_PROVIDER: GetProviderByIdResponse = {
  firstName: 'Unassigned',
  lastName: '',
  userId: null,
} as GetProviderByIdResponse;

export const UNASSIGNED_USER_OPTION: ProviderUniversalSelectOption = {
  firstName: 'Unassigned',
  label: null,
  lastName: ' ',
  providerTypeDetails: {
    externalId: ' ',
    name: ' ',
  },
  userId: null,
  value: null,
};

export const statusOptions: UniversalSelectOption[] = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
];

export const permissionOptions: FilterValue[] = [
  { label: 'Maud', value: 'maud' },
  { label: 'Admin', value: 'admin' },
];

export const NO_USERS_FOUND_TEXT = 'No results found';
export const NO_USERS_FOUND_SUBTEXT =
  'No users match your current criteria. Try removing filters or creating a new user.';
